<!-- SPDX-License-Identifier: AGPL-3.0-or-later -->

<h2 matDialogTitle>Update Account</h2>
<div class="content">
  <mat-dialog-content>
    <app-user-edit-details-form
      [data]="data"
      submitText="Save details"
      (formSubmit)="updateUser($event)"
    ></app-user-edit-details-form>
    <button
      class="cancel-button"
      type="button"
      (click)="cancel()"
      mat-raised-button
      mat-dialog-close
      color="warn"
    >
      Cancel
    </button>
  </mat-dialog-content>
</div>
